import axios from 'axios'
import customerFormat from './json_formats/CustomerFormat'
import saleFormat from './json_formats/SaleFormat'
import productFormat from './json_formats/ProductFormat'
import {
    // arrayToBackEndFormat,
    // arrayToFrontEndFormat,
    // objectToFrontEndFormat,
    objectToBackendFormat,
} from '@/services/ObjectFormatter'

const api = process.env.VUE_APP_API_ROUTE
const saleEndpoint = api + '/pos_sale'
const modifySaleEndpoint = saleEndpoint + '/modify'
const quotationEndpoint = api + '/sl_sale_quotation'
const internalConsumptionEndpoint = api + '/pos_internal_consumption'
const employeeSaleEndpoint = api + '/pos_employee_sale'

// const toBackendArray = array => {
//     array = array.map(item => {
//         objectToBackendFormat(item.customer, customerFormat)
//         objectToBackendFormat(item.saleDetail, productFormat)
//     })
//     array = arrayToBackEndFormat(array, saleFormat)
//     return array
// }

const toBackendObject = obj => {
    if (obj.customer) objectToBackendFormat(obj.customer, customerFormat)
    if (obj.saleDetail) objectToBackendFormat(obj.saleDetail, productFormat)
    obj = objectToBackendFormat(obj, saleFormat)
    return obj
}

const store = async function(sale, editMode = false) {
    sale = toBackendObject(sale)
    let originalType = JSON.parse(JSON.stringify(sale.pos_sale_type))
    let endpoint = saleEndpoint
    if (sale.pos_sale_type == 3) {
        endpoint = quotationEndpoint
        sale.pos_sale_type = 1
    }
    if (sale.pos_sale_type == 4) endpoint = internalConsumptionEndpoint
    if (sale.pos_sale_type == 5) endpoint = employeeSaleEndpoint
	// this one should be always last
    if (editMode) endpoint = modifySaleEndpoint

    try {
        const response = await axios.post(endpoint, sale)
        sale.pos_sale_type = originalType
        return response
    } catch (error) {
        if (error.response) return error.response
        throw error
    }
}

const destroy = async id => {
    let response = await axios.delete(saleEndpoint + '/' + id)
    return response
}

const ticketListIncludes =
    'g_seller_user.hr_employee,pos_detail_sales.wh_product,pos_detail_sales.wh_warehouse,g_state'

const getTicketList = async function() {
    let query = saleEndpoint
    query += `?include=${ticketListIncludes}&filter[g_state_id]=17&limit=-1&sort=-created_at`
    // query += `?include=g_seller_user.hr_employee,pos_detail_sales.wh_product,pos_detail_sales.wh_warehouse&limit=10&sort=-created_at`
    try {
        const response = await axios.get(query)
        return response
    } catch (error) {
        return error.response
    }
}

const getRejectedTicketList = async function() {
    let query = saleEndpoint
    query += `?include=${ticketListIncludes}&filter[g_state_id]=18&filter[today]=true&limit=-1&sort=-created_at`
    // query += `?include=g_seller_user.hr_employee,pos_detail_sales.wh_product,pos_detail_sales.wh_warehouse&limit=10&sort=-created_at`
    try {
        const response = await axios.get(query)
        return response
    } catch (error) {
        return error.response
    }
}

const getTransactionTypes = () => {
    return [
        {
            id: 1,
            name: 'ticket',
            displayName: 'Boleta',
            icon: 'receipt',
            color: 'primary',
        },
        {
            id: 2,
            name: 'invoice',
            displayName: 'Factura',
            icon: 'equalizer',
            color: 'grey darken-2',
        },
        {
            id: 3,
            name: 'quotation',
            displayName: 'Cotización',
            icon: 'assignment',
            color: 'teal darken-2',
        },
        {
            id: 4,
            name: 'internal_consumption',
            displayName: 'Consumo interno',
            icon: 'play_for_work',
            color: 'purple darken-4',
        },
        {
            id: 5,
            name: 'employee_sale',
            displayName: 'Venta al Personal',
            icon: 'account_box',
            color: 'green darken-4',
        },
        {
            id: 6,
            name: 'change_service_order',
            displayName: 'Cambio',
            icon: 'compare_arrows',
            color: 'amber darken-2',
        },
    ]
}

export default {
    store,
    getTransactionTypes,
    getTicketList,
    destroy,
    getRejectedTicketList,
}
